import * as React from 'react'
import { Col, Container, Row } from 'react-grid-system'
import { FiArrowRight } from 'react-icons/fi'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import colors from '../assets/colors/colors'

interface StyledInterface {
    color: any
}
export default function Guide() {

    const [part, setPart] = React.useState<number>(0)

    return (
        <>
            <Content color={colors}>
                <Container >
                    <div className='text-center'><h1 className='pb-4'>Vamos a crear tu primera Sescción👇</h1></div>
                    <section className='w-100'>
                        {
                            part === 1 && (
                                <div>
                                    <input
                                        type="text"
                                        placeholder="Nombre de la categoría"
                                        className="form-control"
                                        id="name"
                                    // onChange={onChange}
                                    // value={form.name}
                                    />
                                </div>
                            )
                        }

                        <Row className='mt-4 '>
                            <Col xs={6}>
                                <Link to="/admin-restaurant" className="btn btn-secundary">Salir</Link>
                            </Col>
                            <Col xs={6} className="text-end">
                                <button className='btn btn-primary'>Siguiente<FiArrowRight /></button>
                            </Col>
                        </Row>
                    </section>
                </Container>
            </Content>
        </>
    )
}


const Content = styled.div<StyledInterface>`
    width: 100%;
    height: 100vh;
    background:white;
    position: fixed;
    top: 0;
    left: 0;
    padding: 5em 0;
        h1, h2 {
        margin: 0.5em 0;
        font-size: 2.5em;
        font-weight: bold;
        color: ${props => props.color.black};
        @media screen and (max-width: 500px) {
            font-size: 1.8em;
        }
    }
    input {
        display:block;
        width:100%;
    }
`